// CONTINUE THE NUMBERING THE RACK ALREADY USES. His complaint 3 was *"I need to add a shelf to a
// VCR and I have no idea how"* — and the dangerous half of that is a new shelf landing on a code
// that already exists. So the plan is READ off the rack's own shelves: the prefix they use, how
// many digits they pad to, and the highest number reached. Nothing is created on a guess, and the
// exact codes are shown before it commits.
export function nextShelfPlan(rackCode, existing, count) {
  const own = (existing || [])
    .map((c) => String(c.short_code || ""))
    .filter((c) => c.startsWith(`${rackCode}-`))
    .map((c) => c.slice(rackCode.length + 1))
    .filter((seg) => seg && !seg.includes("-"));          // this rack's own first level only
  const parsed = own.map((s) => s.match(/^([A-Za-z]+)(\d+)$/)).filter(Boolean);
  let prefix = "L", pad = 1, start = 1;
  if (parsed.length) {
    const tally = {};
    parsed.forEach((m) => { const k = m[1].toUpperCase(); tally[k] = (tally[k] || 0) + 1; });
    prefix = Object.keys(tally).sort((a, b) => tally[b] - tally[a] || a.localeCompare(b))[0];
    const mine = parsed.filter((m) => m[1].toUpperCase() === prefix);
    pad = Math.max(...mine.map((m) => m[2].length));
    start = Math.max(...mine.map((m) => parseInt(m[2], 10))) + 1;
  }
  const n = Math.max(1, Math.min(parseInt(count, 10) || 1, 60));
  const codes = [];
  for (let i = 0; i < n; i++) codes.push(`${rackCode}-${prefix}${String(start + i).padStart(pad, "0")}`);
  return { prefix, pad, start, count: n, codes, existingCount: own.length };
}
